import { ActionDialogAttributes, InstallerCapacity } from '@/types';

import WithSteps from '@/apps/office/containers/table/shared/dialogs/with-steps';
import SmartTable from '@/apps/office/containers/smart-table';

type FormData = {
  selectedItems: InstallerCapacity[];
};

export default WithSteps<FormData, ActionDialogAttributes<InstallerCapacity>>({
  title: 'office.dialogs.installations.capacity.remove.title',

  formData() {
    return {
      selectedItems: this.$attrs.items.slice(),
    };
  },

  steps: [
    {
      component: SmartTable,

      isValid() {
        return this.$data.selectedItems.length > 0;
      },

      props() {
        return {
          items: this.$attrs.items,
          columns: ['id', 'installerName', 'year', 'week', 'capacity'],
          settings: 'planning/capacity/settings',
          showSelect: true,
        };
      },

      labels: {
        action() {
          return this.$t('office.dialogs.installations.capacity.remove.action', [
            this.$data.selectedItems.length,
          ]).toString();
        },
      },

      value: {
        get() {
          return this.$data.selectedItems;
        },

        set(items: InstallerCapacity[]) {
          this.$data.selectedItems = items;
        },
      },

      async afterStep() {
        for (let item of this.$data.selectedItems) {
          await this.$store.dispatch('planning/capacity/item:delete', item);
        }

        this.$store.dispatch('planning/capacity/search');
      },
    },
  ],
});
